import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import NotificationList from "../../containers/NotificationList";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `nav-tab-${index}`,
        'aria-controls': `nav-tabpanel-${index}`,
    };
}


function LinkTab(props) {
    return (
        <Tab
            component="a"
            onClick={(event) => {
                event.preventDefault();
            }}
            {...props}
        />
    );
}

export default function NotificationTabs(props) {

    const [value, setValue] = React.useState(props.activeTab);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeTab = (tabNo) => {
        setValue(tabNo);
    }

    useEffect(() => {
        setValue(props.activeTab);
    }, [props.activeTab]);

    return (
        <div className='notificaiton-tabs'>
            {/* <AppBar position="static">
                <Tabs
                    // variant="fullWidth"
                    value={value}
                    onChange={handleChange}
                    aria-label="notification-tabs"
                >
                    <LinkTab label="Current" href="/" {...a11yProps(0)} />
                    <LinkTab label="History" href="/" {...a11yProps(1)} />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0} className="notification-tab-panel">
                <NotificationList
                    clear={props.clear}
                    isEnableClear={true}
                    makeAPICall={props.makeAPICall}
                    updateNotificationNumber={props.updateNotificationNumber}
                    enableHistoryNotificaitons={false}
                />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <NotificationList
                    clear={props.clear}
                    isEnableClear={false}
                    makeAPICall={props.makeAPICall}
                    updateNotificationNumber={props.updateNotificationNumber}
                    enableHistoryNotificaitons={true}
                />
            </TabPanel> */}
            <div className='notificaiton-tabs-custom'>
                <a className={value === 0 ? 'active' : ''} onClick={() => handleChangeTab(0)}>Current</a>
                <a className={value === 1 ? 'active' : ''} onClick={() => handleChangeTab(1)}>History</a>
            </div>
            <div>
                {
                    value === 0 && (
                        <NotificationList
                            clear={props.clear}
                            isEnableClear={true}
                            makeAPICall={props.makeAPICall}
                            updateNotificationNumber={props.updateNotificationNumber}
                            enableHistoryNotificaitons={false}
                        />
                    )
                }

                {
                    value === 1 && (
                        <NotificationList
                            clear={props.clear}
                            isEnableClear={false}
                            makeAPICall={props.makeAPICall}
                            updateNotificationNumber={props.updateNotificationNumber}
                            enableHistoryNotificaitons={true}
                        />
                    )
                }
            </div>
        </div>
    );
}
